import HomePage from './HomePage';
export * from './HomePage';
export default HomePage;
